import styled, { css } from "styled-components";
import DefaultRow from "components/Form/Row";

export const UnsuccesfullListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px;
`;

export const Email = styled.div`
  flex: 1;
  width: 50%;
`;

export const Reason = styled.div`
  flex: 1;
  width: 50%;
`;

export const GroupRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}
`;
export const TextInformationFile = styled.text`
  font-size: 15px;
  font-family: "Roboto";
  font-weight: 400;
  margin-top: 0px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;

export const ContainerUpload = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 55px;
`;

export const ContainerResult = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const ContainerTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TableHeader = styled.text`
  display: flex;
  font-family: "Roboto";
  color: #757575;
  font-weight: 900;
  font-size: 18px;
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 28px;
  width: 50%;
`;
export const TitleResult = styled.text`
  color: ${({ isSuccess }) => (isSuccess ? "#84cfcb" : "red")};
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 14px;
  margin-left: 10px;
`;

export const NumberSucces = styled.text`
  font-size: 18px;
  font-weight: 400;
  margin-left: 10px;
`;

export const Row = styled(DefaultRow)`
  gap: 200px;
`;
